export const NotificationSubscription = {
  RequestCreated: 'RequestCreated',
  OrderCreated: 'OrderCreated',
  OrderUpdated: 'OrderUpdated',
  OrderDeleted: 'OrderDeleted',
  OrderUnassigned: 'OrderUnassigned',
  OrdersStatusUpdate: 'OrdersStatusUpdate',
  InventoryCaptureCompleted: 'InventoryCaptureCompleted',
  InventoryStockChanged: 'InventoryStockChanged',
};
